module.exports = __webpack_public_path__ + "img/ep-4.a657eec9.jpg";